import React from 'react';
import { Outlet } from 'react-router-dom';

function EmployeeBasePage() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default EmployeeBasePage;
